import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  IsCreationProcess,
  SetSidenavCollapsed,
  SetSidenavHovered,
  ToggleSidenavCollapsed,
} from './ui.actions';

export class UIStateModel {
  sidenavCollapsed: boolean;
  sidenavHovered: boolean;
  isCreationProcess: boolean;
}

@State<UIStateModel>({
  name: 'ui',
  defaults: {
    sidenavCollapsed: false,
    sidenavHovered: false,
    isCreationProcess: false,
  },
})
@Injectable()
export class UIState {
  @Selector()
  static sidenavCollapsed(state: UIStateModel): boolean {
    return state.sidenavCollapsed;
  }

  @Selector()
  static sidenavHovered(state: UIStateModel): boolean {
    return state.sidenavHovered;
  }

  @Selector()
  static isCreationProcess(state: UIStateModel): boolean {
    return state.isCreationProcess;
  }

  @Selector()
  static menuWidth(state: UIStateModel): number {
    return state.sidenavCollapsed ? (state.sidenavHovered ? 230 : 64) : 230;
  }

  @Action(ToggleSidenavCollapsed)
  toggleSidenavCollapsed(ctx: StateContext<UIStateModel>) {
    const state = ctx.getState();
    ctx.patchState({
      sidenavCollapsed: !state.sidenavCollapsed,
    });
  }

  @Action(SetSidenavHovered)
  toggleSidenavHovered(ctx: StateContext<UIStateModel>, { hovered }: SetSidenavHovered) {
    ctx.patchState({
      sidenavHovered: hovered,
    });
  }

  @Action(SetSidenavCollapsed)
  setSidenavCollapsed(
    ctx: StateContext<UIStateModel>,
    { collapsed }: SetSidenavCollapsed,
  ) {
    ctx.patchState({
      sidenavCollapsed: collapsed,
    });
  }

  @Action(IsCreationProcess)
  isCreationProcess(ctx: StateContext<UIStateModel>, { show }: IsCreationProcess) {
    ctx.patchState({ isCreationProcess: show });
  }
}
